import React from 'react'
import { TranslationProvider } from '~/components/shared/TranslationProvider'
import translations from './locales.json'
import FeedbackModal from './FeedbackModal'

const RateUsFeedback = ({
  locale,
  is_inline_link,
  is_mobile_menu,
  program_level,
  btn_text,
  is_button,
}) => {
  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope="javascript.components.RateUsFeedback"
    >
      <FeedbackModal
        isInlineLink={is_inline_link}
        programLevel={program_level}
        btnText={btn_text}
        isMobileMenu={is_mobile_menu}
        isButton={is_button}
      />
    </TranslationProvider>
  )
}

export default RateUsFeedback
